import { COLORS } from '../colors';

export const fillColors = {
  '$fill-accent-dark': COLORS.romeo.$07,
  '$fill-accent-light': COLORS.romeo.$05,
  '$fill-attention': COLORS.andes.$06,
  '$fill-caution-dark': COLORS.fuji.$05,
  '$fill-caution-light': COLORS.fuji.$03,
  '$fill-disabled-button': COLORS.romeo.$02,
  '$fill-disabled-dark': COLORS.tango.$07,
  '$fill-disabled-light': COLORS.tango.$05,
  '$fill-imported-dark': COLORS.rocky.$06,
  '$fill-imported-light': COLORS.rocky.$03,
  '$fill-neutral': COLORS.zulu.$04,
  '$fill-primary': COLORS.zulu.$08,
  '$fill-success-dark': COLORS.everest.$04,
  '$fill-success-light': COLORS.everest.$01,
  '$fill-unclear': COLORS.montblanc.$06,
  '$fill-warning-dark': COLORS.etna.$06,
  '$fill-warning-light': COLORS.etna.$01,
  '$fill-white': COLORS.yuma.$01,
} as const;
